var render, staticRenderFns
import script from "./SysAdminBase.vue?vue&type=script&lang=js&"
export * from "./SysAdminBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c72c2e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c72c2e0')) {
      api.createRecord('7c72c2e0', component.options)
    } else {
      api.reload('7c72c2e0', component.options)
    }
    
  }
}
component.options.__file = "src/components/Sysadmin/SysAdminBase.vue"
export default component.exports